import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';

export const EMPTY_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.EMPTY,
    boxEdge: null,
    vertices: null
};
